import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '../context/store';
import toast from 'react-hot-toast';

const C = { prune:'#4A1942',pruneL:'#6B2E62',pruneD:'#2D0F28',or:'#C9A84C',creme:'#FDF6EC',cremeD:'#F5E8D3',noir:'#1A0F18',gris:'#5C4A58',grisM:'#8B7A86' };

export default function Login() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuthStore();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success('Bienvenue !');
      navigate(searchParams.get('redirect') || '/boutique');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Email ou mot de passe incorrect');
    } finally { setLoading(false); }
  };

  const inp = { width: '100%', padding: '12px 16px', border: `1.5px solid ${C.cremeD}`, borderRadius: 10, fontSize: 14, fontFamily: 'DM Sans, sans-serif', outline: 'none', color: C.noir, background: 'white', boxSizing: 'border-box', transition: 'border-color .2s' };
  const lbl = { display: 'block', fontSize: 11, fontFamily: 'monospace', textTransform: 'uppercase', letterSpacing: '.1em', color: C.grisM, marginBottom: 8 };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', background: C.creme }}>
      {/* Panneau gauche décoratif */}
      <div style={{ flex: 1, background: `linear-gradient(135deg, ${C.pruneD} 0%, ${C.prune} 60%, ${C.pruneL} 100%)`, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 48, minWidth: 0 }}>
        <div style={{ textAlign: 'center', color: C.creme }}>
          <div style={{ width: 72, height: 72, background: 'rgba(201,168,76,.15)', borderRadius: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px', fontFamily: 'Georgia,serif', fontSize: 28, fontWeight: 600, color: C.or, border: '1px solid rgba(201,168,76,.3)' }}>FL</div>
          <h1 style={{ fontFamily: 'Georgia, serif', fontWeight: 300, fontSize: 40, marginBottom: 16, letterSpacing: '.05em' }}>FABI LUXE</h1>
          <p style={{ fontSize: 16, opacity: .7, lineHeight: 1.8 }}>Mode africaine haut de gamme<br/>Côte d'Ivoire</p>
          <div style={{ marginTop: 48, display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            {['🌺 Wax','✨ Bazin','👘 Boubou','🎽 Moderne'].map(l => (
              <span key={l} style={{ background: 'rgba(201,168,76,.12)', border: '1px solid rgba(201,168,76,.25)', color: C.or, padding: '6px 14px', borderRadius: 20, fontSize: 12, fontFamily: 'monospace' }}>{l}</span>
            ))}
          </div>
        </div>
      </div>

      {/* Formulaire */}
      <div style={{ width: 480, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '48px 40px', background: 'white' }}>
        <div style={{ width: '100%', maxWidth: 380 }}>
          <h2 style={{ fontFamily: 'Georgia, serif', fontWeight: 300, fontSize: 32, color: C.pruneD, marginBottom: 8 }}>Connexion</h2>
          <p style={{ color: C.grisM, fontSize: 14, marginBottom: 36 }}>Accédez à votre compte Fabi Luxe</p>
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            {[
              { label: 'Adresse email', key: 'email', type: 'email', placeholder: 'votre@email.com' },
              { label: 'Mot de passe', key: 'password', type: 'password', placeholder: '••••••••' },
            ].map(f => (
              <div key={f.key}>
                <label style={lbl}>{f.label}</label>
                <input type={f.type} value={form[f.key]} onChange={set(f.key)} placeholder={f.placeholder} required style={inp}
                  onFocus={e => e.target.style.borderColor = C.prune}
                  onBlur={e => e.target.style.borderColor = C.cremeD} />
              </div>
            ))}
            <button type="submit" disabled={loading} style={{ padding: '14px', background: loading ? C.grisM : `linear-gradient(135deg, ${C.prune}, ${C.pruneL})`, color: C.or, border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'DM Sans, sans-serif', boxShadow: loading ? 'none' : `0 4px 20px rgba(74,25,66,.3)`, marginTop: 8, transition: 'all .2s' }}>
              {loading ? '⏳ Connexion...' : 'Se connecter →'}
            </button>
          </form>
          <div style={{ marginTop: 28, paddingTop: 28, borderTop: `1px solid ${C.cremeD}`, textAlign: 'center' }}>
            <p style={{ fontSize: 14, color: C.grisM }}>Pas encore de compte ?{' '}
              <Link to="/inscription" style={{ color: C.prune, fontWeight: 600, textDecoration: 'none' }}>Créer un compte</Link>
            </p>
            <Link to="/boutique" style={{ display: 'inline-block', marginTop: 12, fontSize: 13, color: C.grisM, textDecoration: 'none' }}>← Continuer sans compte</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
